export const SITE_BASE_URL = 'https://www.fergusonhome.com';
